export default __webpack_public_path__ + "static/media/jpg.819b156c.svg";